export default "__VITE_ASSET__77c0da53__"